import axios, { endPoints } from 'utils/api';

const SET_RESULTS = 'qnResults/SET';
const SET_LOADING = 'qnResults/SET_LOADING';
const SET_ERROR = 'qnResults/SET_ERROR';

export const setResults = (data) => ({ type: SET_RESULTS, data });
export const setResultsLoading = (loading) => ({ type: SET_LOADING, loading });
export const setResultsError = (error) => ({ type: SET_ERROR, error });

const INITIAL_STATE = { byVersion: {}, loading: false, error: null };

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case SET_RESULTS: {
            const key = `${action.data.questionnaireId}:${action.data.questionnaireVersion}`;

            return {
                ...state,
                byVersion: { ...state.byVersion, [key]: action.data },
                error: null
            };
        }

        case SET_LOADING:
            return { ...state, loading: action.loading };

        case SET_ERROR:
            return { ...state, error: action.error, loading: false };

        default:
            return state;
    }
}

export const fetchQuestionnaireResults = (id, version) => async (dispatch) => {
    dispatch(setResultsLoading(true));

    try {
        const response = await axios.get(
            `${endPoints.questionnaires}/${id}/versions/${version}/results`
        );

        dispatch(setResults({
            questionnaireId: id,
            questionnaireVersion: Number(version),
            ...response.data
        }));
    } catch (error) {
        dispatch(setResultsError(error.message || 'Failed to load results'));
    } finally {
        dispatch(setResultsLoading(false));
    }
};
